import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/images/icons/open.svg';
const _hoisted_1 = {
  class: "row"
};
const _hoisted_2 = {
  class: "col-12"
};
const _hoisted_3 = {
  class: "row"
};
const _hoisted_4 = {
  class: "col-12"
};
const _hoisted_5 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_6 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_7 = {
  class: "row mt-3"
};
const _hoisted_8 = {
  class: "col-12 mb-3 fw-medium fsi-16"
};
const _hoisted_9 = {
  key: 0,
  class: "row mb-3 mt-1"
};
const _hoisted_10 = {
  class: "col-12 mb-1"
};
const _hoisted_11 = {
  class: "mt-1"
};
const _hoisted_12 = {
  class: "row"
};
const _hoisted_13 = {
  class: "col-12"
};
const _hoisted_14 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_15 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_16 = {
  class: "row"
};
const _hoisted_17 = {
  class: "col-12 mb-3 mt-3"
};
const _hoisted_18 = {
  key: 0,
  class: "i-layer",
  "element-loading-text": "Loading..."
};
const _hoisted_19 = {
  class: "row mt-3",
  ref: "signContent"
};
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-2 col-12 text-left fw-medium d-lg-block d-none fsi-16"
}, "From", -1);
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-2 col-12 text-left fw-bold d-lg-none d-block fsi-16"
}, "From", -1);
const _hoisted_22 = {
  class: "col-lg-10 col-12 d-lg-flex d-none text-lg-right text-left fw-medium fsi-16 justify-content-lg-end justify-content-start"
};
const _hoisted_23 = {
  class: "d-lg-none d-block"
};
const _hoisted_24 = {
  class: "col-lg-10 col-12 text-lg-right text-left fw-medium fsi-14 d-lg-none d-flex justify-content-lg-end"
};
const _hoisted_25 = {
  class: "row mt-3"
};
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-2 col-12 text-left fw-medium d-lg-block d-none fsi-16"
}, "To", -1);
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-2 col-12 text-left fw-bold d-lg-none d-block fsi-16"
}, "To", -1);
const _hoisted_28 = {
  class: "col-lg-10 col-12 d-lg-flex d-none text-lg-right text-left fw-medium fsi-16 justify-content-lg-end justify-content-start"
};
const _hoisted_29 = {
  class: "d-lg-none d-block"
};
const _hoisted_30 = {
  class: "col-lg-10 col-12 d-lg-none d-flex text-lg-right text-left fw-medium fsi-14 justify-content-lg-end justify-content-start"
};
const _hoisted_31 = {
  class: "row mt-3"
};
const _hoisted_32 = {
  class: "col-lg-3 col-12 text-left fw-medium d-lg-block d-none fsi-16"
};
const _hoisted_33 = {
  class: "col-lg-3 col-12 text-left fw-bold d-lg-none d-block fsi-16"
};
const _hoisted_34 = {
  class: "col-lg-9 col-12 text-lg-right text-left fw-medium fsi-16 d-lg-block d-none"
};
const _hoisted_35 = {
  class: "col-lg-9 col-12 text-lg-right text-left fw-medium fsi-14 d-lg-none d-block"
};
const _hoisted_36 = {
  class: "col-lg-9 col-12 text-lg-right text-left fw-medium fsi-16 d-lg-block d-none"
};
const _hoisted_37 = {
  class: "col-lg-9 col-12 text-lg-right text-left fw-medium fsi-14 d-lg-none d-block"
};
const _hoisted_38 = {
  key: 0,
  class: "row mt-3"
};
const _hoisted_39 = {
  class: "col-lg-3 col-12 text-left fw-medium d-lg-block d-none fsi-16"
};
const _hoisted_40 = {
  class: "col-lg-3 col-12 text-left fw-bold d-lg-none d-block fsi-16"
};
const _hoisted_41 = {
  class: "col-lg-9 col-12 text-lg-right text-left fw-medium fsi-16 d-lg-block d-none"
};
const _hoisted_42 = {
  class: "col-lg-9 col-12 text-lg-right text-left fw-medium fsi-14 d-lg-none d-block"
};
const _hoisted_43 = {
  key: 1,
  class: "row mt-3"
};
const _hoisted_44 = {
  class: "col-lg-3 col-12 text-left fw-medium d-lg-block d-none fsi-16"
};
const _hoisted_45 = {
  class: "col-lg-3 col-12 text-left fw-bold d-lg-none d-block fsi-16"
};
const _hoisted_46 = {
  class: "col-lg-9 col-12 text-lg-right text-left fw-medium fsi-16 d-lg-block d-none"
};
const _hoisted_47 = {
  class: "col-lg-9 col-12 text-lg-right text-left fw-medium fsi-14 d-lg-none d-block"
};
const _hoisted_48 = {
  key: 1,
  class: "i-layer",
  "element-loading-text": "Loading..."
};
const _hoisted_49 = {
  class: "row"
};
const _hoisted_50 = {
  class: "col-12",
  ref: "signContent"
};
const _hoisted_51 = {
  class: "code-style fw-medium fsi-14 position-relative"
};
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", null, "{", -1);
const _hoisted_53 = {
  class: "code-style-retract"
};
const _hoisted_54 = {
  class: "code-style-retract"
};
const _hoisted_55 = {
  class: "code-style-retract"
};
const _hoisted_56 = {
  class: "code-style-retract"
};
const _hoisted_57 = {
  class: "code-style-retract"
};
const _hoisted_58 = {
  class: "code-style-retract"
};
const _hoisted_59 = {
  class: "code-style-retract"
};
const _hoisted_60 = {
  class: "code-style-retract"
};
const _hoisted_61 = {
  class: "code-style-retract"
};
const _hoisted_62 = {
  class: "code-style-retract"
};
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", null, "}", -1);
const _hoisted_64 = {
  key: 1,
  class: "row mb-2 mt-5"
};
const _hoisted_65 = {
  class: "col-12"
};
const _hoisted_66 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_67 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_68 = {
  class: "col-12 d-flex mb-4 mt-2 align-content-center"
};
const _hoisted_69 = {
  class: "fw-medium fsi-14"
};
const _hoisted_70 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "16px",
    "margin-bottom": "2px",
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_71 = [_hoisted_70];
const _hoisted_72 = {
  key: 1,
  class: "col-12 d-flex justify-content-center align-content-center mt-2"
};
const _hoisted_73 = {
  key: 2,
  class: "col-12 d-flex justify-content-center align-content-center mt-2"
};
const _hoisted_74 = {
  class: "row"
};
const _hoisted_75 = {
  class: "col-12",
  style: {
    "margin-top": "30px"
  }
};
const _hoisted_76 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_77 = {
  class: "mr-1 fw-extra-bold fsi-16"
};
const _hoisted_78 = {
  class: "row"
};
const _hoisted_79 = {
  class: "col-12 mb-2 mt-2"
};
const _hoisted_80 = {
  key: 0,
  class: "row"
};
const _hoisted_81 = {
  class: "col-12 mb-2 mt-4"
};
const _hoisted_82 = {
  class: "i-layer"
};
const _hoisted_83 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_84 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_85 = {
  class: "fw-medium fs-12 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_86 = {
  class: "mr-1 fw-medium fsi-14"
};
const _hoisted_87 = ["href"];
const _hoisted_88 = {
  class: "d-flex justify-content-center"
};
const _hoisted_89 = {
  class: "mt-2 mb-4",
  style: {},
  ref: "qrCodeUrl"
};
const _hoisted_90 = {
  key: 0
};
const _hoisted_91 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_92 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_93 = {
  class: "fw-medium fs-12 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_94 = {
  class: "mr-1 fw-medium fsi-14"
};
const _hoisted_95 = {
  class: "mt-3 d-flex justify-content-center"
};
const _hoisted_96 = {
  class: "mb-2",
  style: {
    "width": "300px",
    "height": "300px",
    "border-radius": "10px",
    "overflow": "hidden"
  }
};
const _hoisted_97 = {
  style: {
    "width": "300px",
    "height": "300px"
  },
  "element-loading-text": "Loading..."
};
const _hoisted_98 = {
  class: "mr-1 fsi-14 fw-medium"
};
const _hoisted_99 = {
  key: 1,
  class: "row"
};
const _hoisted_100 = {
  class: "col-12 mt-4"
};
const _hoisted_101 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_102 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_103 = {
  class: "col-12 mb-2 mt-2"
};
const _hoisted_104 = {
  key: 2
};
const _hoisted_105 = {
  class: "row mb-3 mt-3"
};
const _hoisted_106 = {
  class: "col-12"
};
const _hoisted_107 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_108 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_109 = {
  class: "col-12 d-flex mb-4 mt-2 align-content-center"
};
const _hoisted_110 = {
  class: "fw-medium fsi-14"
};
const _hoisted_111 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "16px",
    "margin-bottom": "2px",
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_112 = [_hoisted_111];
const _hoisted_113 = {
  class: "col-12 d-flex justify-content-center align-content-center mt-2"
};
const _hoisted_114 = {
  key: 0,
  class: "mt-3"
};
const _hoisted_115 = {
  key: 0,
  class: "d-flex justify-content-end"
};
const _hoisted_116 = {
  key: 0,
  class: "d-flex justify-content-end"
};
const _hoisted_117 = {
  key: 1,
  class: "mt-3"
};
const _hoisted_118 = {
  key: 0,
  class: "d-flex justify-content-end"
};
const _hoisted_119 = {
  class: "row mb-3"
};
const _hoisted_120 = {
  class: "col-lg-6 col-12 mb-1 order-lg-1 order-2 mt-lg-0 mt-2"
};
const _hoisted_121 = {
  class: "col-lg-6 col-12 mb-1 order-lg-2 order-1"
};
const _hoisted_122 = {
  key: 0,
  class: "d-flex justify-content-end"
};
const _hoisted_123 = {
  class: "row mb-3"
};
const _hoisted_124 = {
  class: "col-6 mb-1"
};
const _hoisted_125 = {
  class: ""
};
const _hoisted_126 = {
  class: "col-6 mb-1"
};
const _hoisted_127 = {
  class: ""
};
const _hoisted_128 = {
  class: "row position-relative"
};
const _hoisted_129 = {
  class: "col-12 mb-2 mt-4 position-relative"
};
const _hoisted_130 = {
  class: "i-layer",
  ref: "signContent"
};
const _hoisted_131 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_132 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_133 = {
  class: "fw-medium fs-12 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_134 = {
  class: "mr-1 fw-medium fsi-14"
};
const _hoisted_135 = {
  class: "code-style fw-medium fsi-14 position-relative d-flex flex-wrap justify-content-between align-items-center"
};
const _hoisted_136 = {
  key: 1,
  class: "cursor-pointer fsi-14",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_137 = {
  class: "row"
};
const _hoisted_138 = {
  class: "col-12 mt-4"
};
const _hoisted_139 = {
  class: "i-layer"
};
const _hoisted_140 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_141 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_142 = {
  class: "col-12 mb-2"
};
const _hoisted_143 = {
  class: "i-layer pt-2"
};
const _hoisted_144 = {
  key: 0,
  class: "i-layer"
};
const _hoisted_145 = {
  class: "row mb-3 mt-3"
};
const _hoisted_146 = {
  class: "col-12"
};
const _hoisted_147 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_148 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_149 = {
  class: "col-12 d-flex mb-4 mt-2 align-content-center"
};
const _hoisted_150 = {
  class: "fw-medium fsi-14"
};
const _hoisted_151 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "16px",
    "margin-bottom": "2px",
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_152 = [_hoisted_151];
const _hoisted_153 = {
  class: "col-12 d-flex justify-content-center align-content-center mt-2"
};
const _hoisted_154 = {
  key: 1,
  class: "i-layer"
};
const _hoisted_155 = {
  class: "row mb-3 mt-3"
};
const _hoisted_156 = {
  class: "col-6 mb-1"
};
const _hoisted_157 = {
  class: "mt-3"
};
const _hoisted_158 = {
  class: "col-6 mb-1"
};
const _hoisted_159 = {
  class: "mt-3"
};
const _hoisted_160 = {
  key: 1,
  class: "col-12 mb-1"
};
const _hoisted_161 = {
  class: "mt-3"
};
const _hoisted_162 = {
  class: "row position-relative"
};
const _hoisted_163 = {
  class: "col-12 mb-2 mt-4 position-relative"
};
const _hoisted_164 = {
  class: "i-layer",
  ref: "signContent"
};
const _hoisted_165 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_166 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_167 = {
  class: "fw-medium fs-12 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_168 = {
  class: "mr-1 fw-medium fsi-14"
};
const _hoisted_169 = {
  class: "code-style fw-medium fsi-14 position-relative d-flex flex-wrap justify-content-between align-items-center"
};
const _hoisted_170 = {
  key: 1,
  class: "cursor-pointer fsi-14",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_171 = {
  class: "row"
};
const _hoisted_172 = {
  class: "col-12 mt-4"
};
const _hoisted_173 = {
  class: "i-layer"
};
const _hoisted_174 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_175 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_176 = {
  class: "col-12 mb-2"
};
const _hoisted_177 = {
  class: "i-layer pt-2"
};
const _hoisted_178 = {
  key: 0,
  class: "i-layer"
};
const _hoisted_179 = {
  class: "row mb-3 mt-3"
};
const _hoisted_180 = {
  class: "col-12"
};
const _hoisted_181 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_182 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_183 = {
  class: "col-12 d-flex mb-4 mt-2 align-content-center"
};
const _hoisted_184 = {
  class: "fw-medium fsi-14"
};
const _hoisted_185 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "16px",
    "margin-bottom": "2px",
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_186 = [_hoisted_185];
const _hoisted_187 = {
  class: "col-12 d-flex justify-content-center align-content-center mt-2"
};
const _hoisted_188 = {
  key: 1,
  class: "i-layer"
};
const _hoisted_189 = {
  class: "row mb-3 mt-3"
};
const _hoisted_190 = {
  class: "col-6 mb-1"
};
const _hoisted_191 = {
  class: "mt-3"
};
const _hoisted_192 = {
  class: "col-6 mb-1"
};
const _hoisted_193 = {
  class: "mt-3"
};
const _hoisted_194 = {
  key: 1,
  class: "col-12 mb-1"
};
const _hoisted_195 = {
  class: "mt-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SuccessFilled = _resolveComponent("SuccessFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Aim = _resolveComponent("Aim");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_button = _resolveComponent("el-button");
  const _component_RadioBtn = _resolveComponent("RadioBtn");
  const _component_qrcode_stream = _resolveComponent("qrcode-stream");
  const _component_CloseBold = _resolveComponent("CloseBold");
  const _component_el_input = _resolveComponent("el-input");
  const _component_ledger = _resolveComponent("ledger");
  const _component_CopyDocument = _resolveComponent("CopyDocument");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.singerMultiple ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('Onboarding.Please select an address to initiate this proposal')), 1)])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_table, {
    data: $data.singerTables,
    style: {
      "width": "100%"
    },
    "highlight-current-row": true,
    "v-loading": $data.singerTables.length === 0,
    onCellClick: $options.cellClick
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      label: "Approved",
      align: "center",
      width: "100"
    }, {
      default: _withCtx(scope => [scope.row.isOk === true ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_SuccessFilled, {
          color: "blue"
        })]),
        _: 1
      })) : _createCommentVNode("", true), $data.singerTablesCheckIndex === scope.$index && scope.row.isOk === false ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_Aim, {
          color: "blue"
        })]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      align: "center",
      prop: "address",
      label: "Address"
    })]),
    _: 1
  }, 8, ["data", "v-loading", "onCellClick"])])]), !$data.finish ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [!$data.confirmSingerFlag ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
    loading: $data.singMessageLoading,
    class: "btn btn-primary w-100 i-button",
    type: "submit",
    onClick: $options.confirmSinger
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Confirm')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), !$data.finish ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [!$props.singerMultiple || $data.confirmSingerFlag ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('Onboarding.Message Content')), 1)])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_RadioBtn, {
    "disable-tabs": $props.isCallEvm ? ['JSON'] : [],
    tabs: ['DATA', 'JSON'],
    modelValue: $data.radio3,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.radio3 = $event)
  }, null, 8, ["disable-tabs", "modelValue"])])]), $data.radio3 === 'DATA' ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _hoisted_21, _createElementVNode("div", _hoisted_22, [!$props.isCallEvm ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle(`width: ${$data.signMessageMaxWidth * 1.2}px;`),
    class: "link-text-ordinary",
    onClick: _cache[1] || (_cache[1] = $event => $options.gotoAddress($data.singerMsg.From, _ctx.$i18n.locale, _ctx.$i18n.locale))
  }, _toDisplayString($data.singerMsg.From), 5)) : _createCommentVNode("", true), $props.isCallEvm ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    style: _normalizeStyle(`width: ${$data.signMessageMaxWidth * 1.3}px;`),
    class: "link-text-ordinary",
    onClick: _cache[2] || (_cache[2] = $event => $options.gotoAddress($options.address, _ctx.$i18n.locale, _ctx.$i18n.locale))
  }, _toDisplayString($options.isEmpty($options.address) ? '--' : $options.address), 5)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [!$props.isCallEvm ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle(`width: ${$data.signMessageMaxWidth * 1.05}px;`),
    class: "link-text-ordinary",
    onClick: _cache[3] || (_cache[3] = $event => $options.gotoAddress($data.singerMsg.From, _ctx.$i18n.locale, _ctx.$i18n.locale))
  }, _toDisplayString($data.singerMsg.From), 5)) : _createCommentVNode("", true), $props.isCallEvm ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    style: _normalizeStyle(`width: ${$data.signMessageMaxWidth * 1.3}px;`),
    class: "link-text-ordinary",
    onClick: _cache[4] || (_cache[4] = $event => $options.gotoAddress($options.address, _ctx.$i18n.locale, _ctx.$i18n.locale))
  }, _toDisplayString($options.isEmpty($options.address) ? '--' : $options.address), 5)) : _createCommentVNode("", true)])])], 512), _createElementVNode("div", _hoisted_25, [_hoisted_26, _hoisted_27, _createElementVNode("div", _hoisted_28, [!$props.isCallEvm ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle(`width: ${$data.signMessageMaxWidth}px;`),
    class: "link-text-ordinary",
    onClick: _cache[5] || (_cache[5] = $event => $options.gotoAddress($data.singerMsg.To, _ctx.$i18n.locale))
  }, _toDisplayString($data.singerMsg.To), 5)) : _createCommentVNode("", true), $props.isCallEvm ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    style: _normalizeStyle(`width: ${$data.signMessageMaxWidth * 1.3}px;`),
    class: "link-text-ordinary",
    onClick: _cache[6] || (_cache[6] = $event => $options.gotoAddress($props.contractAddress, _ctx.$i18n.locale))
  }, _toDisplayString($props.contractAddress), 5)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [!$props.isCallEvm ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle(`width: ${$data.signMessageMaxWidth}px;`),
    class: "link-text-ordinary",
    onClick: _cache[7] || (_cache[7] = $event => $options.gotoAddress($data.singerMsg.To, _ctx.$i18n.locale))
  }, _toDisplayString($data.singerMsg.To), 5)) : _createCommentVNode("", true), $props.isCallEvm ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    style: _normalizeStyle(`width: ${$data.signMessageMaxWidth * 1.3}px;`),
    class: "link-text-ordinary",
    onClick: _cache[8] || (_cache[8] = $event => $options.gotoAddress($props.contractAddress, _ctx.$i18n.locale))
  }, _toDisplayString($props.contractAddress), 5)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('Onboarding.Method')), 1), _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('Onboarding.Method')), 1), $props.isCallEvm ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_34, _toDisplayString($props.contractMethod), 1), _createElementVNode("div", _hoisted_35, _toDisplayString($props.contractMethod), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_36, "Method ID " + _toDisplayString($data.singerMsg.Method) + ": " + _toDisplayString($data.singerMsg.Method === 2 ? 'Propose' : $data.singerMsg.Method === 23 ? 'changeOwnerAddress' : $data.singerMsg.Method === 30 ? 'changeBeneficiary' : $data.singerMsg.Method === 3844450837 ? 'InvokeEVM' : 'Approval'), 1), _createElementVNode("div", _hoisted_37, "Method ID " + _toDisplayString($data.singerMsg.Method) + ": " + _toDisplayString($data.singerMsg.Method === 2 ? 'Propose' : $data.singerMsg.Method === 23 ? 'changeOwnerAddress' : $data.singerMsg.Method === 30 ? 'changeBeneficiary' : $data.singerMsg.Method === 3844450837 ? 'InvokeEVM' : 'Approval'), 1)], 64))]), $props.isCallEvm ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('Onboarding.params')), 1), _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('Onboarding.params')), 1), _createElementVNode("div", _hoisted_41, _toDisplayString($props.contractParams), 1), _createElementVNode("div", _hoisted_42, _toDisplayString($props.contractParams), 1)])) : _createCommentVNode("", true), !$props.isCallEvm ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('Onboarding.Fee')), 1), _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('Onboarding.Fee')), 1), _createElementVNode("div", _hoisted_46, _toDisplayString($options.fee) + " attoFIL ", 1), _createElementVNode("div", _hoisted_47, _toDisplayString($options.fee) + " attoFIL ", 1)])) : _createCommentVNode("", true)])), [[_directive_loading, $data.singMessageLoading]]) : _createCommentVNode("", true), $data.radio3 === 'JSON' ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_hoisted_52, _createElementVNode("div", _hoisted_53, [_createElementVNode("div", {
    style: _normalizeStyle(`width: ${$data.signMessageMaxWidth}px;`)
  }, " \"From\": \"" + _toDisplayString($props.isCallEvm ? $options.address : $data.singerMsg.From) + "\", ", 5)]), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", {
    style: _normalizeStyle(`width: ${$data.signMessageMaxWidth}px;`)
  }, " \"To\": \"" + _toDisplayString($props.isCallEvm ? $props.contractAddress : $data.singerMsg.To) + "\", ", 5)]), _createElementVNode("div", _hoisted_55, " \"Method\": " + _toDisplayString($data.singerMsg.Method) + ", ", 1), _createElementVNode("div", _hoisted_56, " \"GasFeeCap\": \"" + _toDisplayString($data.singerMsg.GasFeeCap) + "\", ", 1), _createElementVNode("div", _hoisted_57, " \"GasLimit\": " + _toDisplayString($data.singerMsg.GasLimit) + ", ", 1), _createElementVNode("div", _hoisted_58, " \"GasPremium\": \"" + _toDisplayString($data.singerMsg.GasPremium) + "\", ", 1), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", {
    style: _normalizeStyle(`width: ${$data.signMessageMaxWidth}px;`)
  }, "\"Params\":\"" + _toDisplayString($data.singerMsg.Params) + "\",", 5)]), _createElementVNode("div", _hoisted_60, " \"Value\": \"" + _toDisplayString($data.singerMsg.Value) + "\", ", 1), _createElementVNode("div", _hoisted_61, " \"Nonce\": " + _toDisplayString($data.singerMsg.Nonce) + ", ", 1), _createElementVNode("div", _hoisted_62, " \"Version\": " + _toDisplayString($data.singerMsg.Version), 1), _hoisted_63])], 512)])])), [[_directive_loading, $data.singMessageLoading]]) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $props.isCallEvm ? (_openBlock(), _createElementBlock("div", _hoisted_64, [$data.hash !== '' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.$t('Onboarding.Message ID')), 1)])]), _createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("span", {
    class: "link-text-ordinary",
    onClick: _cache[9] || (_cache[9] = $event => $options.gotoHash($data.hash, _ctx.$i18n.locale))
  }, _toDisplayString($data.hash), 1), _createElementVNode("span", {
    style: {
      "margin-left": "3px"
    },
    onClick: _cache[10] || (_cache[10] = $event => $options.gotoHash($data.hash, _ctx.$i18n.locale))
  }, _hoisted_71)])])], 64)) : _createCommentVNode("", true), $options.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_72, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.callEvmMethod
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.btnText === '' ? _ctx.$t("Onboarding.Push") : $data.btnText), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])) : _createCommentVNode("", true), !$options.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_73, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.connectWallet
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.Connect Wallet')) + " " + _toDisplayString($options.isConnecting ? ' (connecting...)' : ''), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !$props.isCallEvm ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [(!$props.singerMultiple || $data.confirmSingerFlag) && !$data.singMessageLoading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, [_createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.$t('Onboarding.Please choose your signature method')), 1)])])]), _createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_createVNode(_component_RadioBtn, {
    "tab-arr": $data.tabOptions1,
    modelValue: $data.radio4,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.radio4 = $event)
  }, null, 8, ["tab-arr", "modelValue"])])]), $data.radio4 === 'STFIL Wallet' ? (_openBlock(), _createElementBlock("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [_createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.$t('Onboarding.Sign Message')), 1)]), _createElementVNode("div", _hoisted_85, [_createElementVNode("span", _hoisted_86, [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Sign message via related offline signature account2')), 1), _createElementVNode("a", {
    target: "_blank",
    href: $options.notInstalled,
    class: "link-text ml-1"
  }, _toDisplayString(_ctx.$t('Onboarding.Not installed?')), 9, _hoisted_87)])]), _createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, null, 512)]), $data.openScanQr && $data.qrInputIsScan ? (_openBlock(), _createElementBlock("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.$t('Onboarding.Message Push')), 1)]), _createElementVNode("div", _hoisted_93, [_createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.$t('Onboarding.Scan the QR code after offline')), 1)]), _createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [_createVNode(_component_qrcode_stream, {
    onDecode: $options.onDecode,
    onInit: $options.onInit
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_97, null, 512), [[_directive_loading, $data.cameraOpen]])]),
    _: 1
  }, 8, ["onDecode", "onInit"])])]), _createElementVNode("div", {
    class: "mb-1 d-flex align-items-center justify-content-center cursor-pointer",
    style: {
      "color": "#727272"
    },
    onClick: _cache[12] || (_cache[12] = (...args) => $options.closeCameraOpen && $options.closeCameraOpen(...args))
  }, [_createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.$t('common.close')), 1), _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CloseBold)]),
    _: 1
  })])])) : _createCommentVNode("", true), !$data.qrInputIsScan ? (_openBlock(), _createElementBlock("div", _hoisted_99, [_createElementVNode("div", _hoisted_100, [_createElementVNode("div", _hoisted_101, [_createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.$t('Onboarding.Please enter the result')), 1)])]), _createElementVNode("div", _hoisted_103, [_createVNode(_component_el_input, {
    disabled: $data.loading,
    modelValue: $data.qrSingerInput,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.qrSingerInput = $event),
    rows: 3,
    type: "textarea",
    resize: "none"
  }, null, 8, ["disabled", "modelValue"])])])) : _createCommentVNode("", true), $options.isHavePushResultCid() ? (_openBlock(), _createElementBlock("div", _hoisted_104, [_createElementVNode("div", _hoisted_105, [_createElementVNode("div", _hoisted_106, [_createElementVNode("div", _hoisted_107, [_createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.$t('Onboarding.Message ID')), 1)])]), _createElementVNode("div", _hoisted_109, [_createElementVNode("div", _hoisted_110, [_createElementVNode("span", {
    class: "link-text-ordinary",
    onClick: _cache[14] || (_cache[14] = $event => $options.gotoHash($data.pushResultCid['/'], _ctx.$i18n.locale))
  }, _toDisplayString($data.pushResultCid['/']), 1), _createElementVNode("span", {
    style: {
      "margin-left": "3px"
    },
    onClick: _cache[15] || (_cache[15] = $event => $options.gotoHash($data.pushResultCid['/'], _ctx.$i18n.locale))
  }, _hoisted_112)])]), _createElementVNode("div", _hoisted_113, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.tryAgainMessage
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.loading ? 'Loading...' : _ctx.$t('Onboarding.Try Again')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])])])) : _createCommentVNode("", true), !$options.isHavePushResultCid() ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [!$props.singerMultiple ? (_openBlock(), _createElementBlock("div", _hoisted_114, [!$data.loading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$data.qrInputIsScan ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [!$data.openScanQr && !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_115, [_createElementVNode("div", {
    class: "fw-medium mr-3 mb-2 fsi-14 cursor-pointer",
    style: {
      "color": "#8b8b8b !important"
    },
    onClick: _cache[16] || (_cache[16] = (...args) => $options.textImport && $options.textImport(...args))
  }, _toDisplayString(_ctx.$t('Onboarding.Text Import')), 1)])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
    loading: $data.openScanQr,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.nextQrCode
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Click here to scan the QR code')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])], 64)) : _createCommentVNode("", true), !$data.qrInputIsScan ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [!$data.openScanQr && !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_116, [_createElementVNode("div", {
    class: "fw-medium mr-3 mb-2 fsi-14 cursor-pointer",
    style: {
      "color": "#8b8b8b !important"
    },
    onClick: _cache[17] || (_cache[17] = (...args) => $options.scanQr && $options.scanQr(...args))
  }, _toDisplayString(_ctx.$t('Onboarding.Qr Scan')), 1)])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
    loading: $data.openScanQr,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.pushSinger
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Push')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $data.loading ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    loading: $data.loading,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.nextQrCode
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Push')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $props.singerMultiple ? (_openBlock(), _createElementBlock("div", _hoisted_117, [!$data.loading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$data.qrInputIsScan ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [!$data.openScanQr && !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_118, [_createElementVNode("div", {
    class: "fw-medium mr-3 mb-2 fsi-14 cursor-pointer",
    style: {
      "color": "#8b8b8b !important"
    },
    onClick: _cache[18] || (_cache[18] = (...args) => $options.textImport && $options.textImport(...args))
  }, _toDisplayString(_ctx.$t('Onboarding.Text Import')), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_119, [_createElementVNode("div", _hoisted_120, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.confirmSingerReset
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Rest')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])]), _createElementVNode("div", _hoisted_121, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
    loading: $data.openScanQr,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.nextQrCode
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Scan QR code here')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])])])], 64)) : _createCommentVNode("", true), !$data.qrInputIsScan ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [!$data.openScanQr && !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_122, [_createElementVNode("div", {
    class: "fw-medium mr-3 mb-2 fsi-14 cursor-pointer",
    style: {
      "color": "#8b8b8b !important"
    },
    onClick: _cache[19] || (_cache[19] = (...args) => $options.scanQr && $options.scanQr(...args))
  }, _toDisplayString(_ctx.$t('Onboarding.Qr Scan')), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_123, [_createElementVNode("div", _hoisted_124, [_createElementVNode("div", _hoisted_125, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.confirmSingerReset
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Rest')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])]), _createElementVNode("div", _hoisted_126, [_createElementVNode("div", _hoisted_127, [_createVNode(_component_el_button, {
    loading: $data.openScanQr,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.pushSinger
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Push')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])])])], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $data.loading ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    loading: $data.loading,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.nextQrCode
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Push')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true), $data.radio4 === 'Ledger' ? (_openBlock(), _createBlock(_component_ledger, {
    key: 1,
    message: $data.singerMsg,
    waitPushResult: $data.loading,
    onSignedMessage: $options.pushLedgerSinger
  }, null, 8, ["message", "waitPushResult", "onSignedMessage"])) : _createCommentVNode("", true), $data.radio4 === 'Lotus' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createElementVNode("div", _hoisted_128, [_createElementVNode("div", _hoisted_129, [_createElementVNode("div", _hoisted_130, [_createElementVNode("div", _hoisted_131, [_createElementVNode("span", _hoisted_132, _toDisplayString(_ctx.$t('Onboarding.Sign Message')), 1)]), _createElementVNode("div", _hoisted_133, [_createElementVNode("span", _hoisted_134, _toDisplayString(_ctx.$t('Onboarding.Sign message via related offline signature account')), 1)]), _createElementVNode("div", _hoisted_135, [_createElementVNode("div", {
    class: "d-none d-lg-block",
    style: _normalizeStyle([`width: ${$data.signMessageMaxWidth * 1.2}px;`, {
      "word-break": "normal",
      "word-wrap": "break-word"
    }])
  }, " lotus wallet sign " + _toDisplayString($data.singerMsg.From) + " " + _toDisplayString($data.bytesToBeSign), 5), _createElementVNode("div", {
    class: "d-lg-none d-block",
    style: _normalizeStyle([`width: ${$data.signMessageMaxWidth}px;`, {
      "word-break": "normal",
      "word-wrap": "break-word"
    }])
  }, " lotus wallet sign " + _toDisplayString($data.singerMsg.From) + " " + _toDisplayString($data.bytesToBeSign), 5), !$data.isCopy ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "cursor-pointer copy-text fsi-18",
    onClick: _cache[20] || (_cache[20] = (...args) => $options.copy && $options.copy(...args)),
    style: {
      "border": "1px solid #dcdcdc",
      "padding": "6px",
      "display": "inline-flex",
      "border-radius": "5px"
    }
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.isCopy ? (_openBlock(), _createElementBlock("div", _hoisted_136, " copied ")) : _createCommentVNode("", true)])], 512)])]), _createElementVNode("div", _hoisted_137, [_createElementVNode("div", _hoisted_138, [_createElementVNode("div", _hoisted_139, [_createElementVNode("div", _hoisted_140, [_createElementVNode("span", _hoisted_141, _toDisplayString(_ctx.$t('Onboarding.Please enter the result')), 1)])])]), _createElementVNode("div", _hoisted_142, [_createElementVNode("div", _hoisted_143, [_createVNode(_component_el_input, {
    disabled: $data.loading,
    modelValue: $data.inputSingerResult,
    "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.inputSingerResult = $event),
    rows: 3,
    type: "textarea",
    resize: "none"
  }, null, 8, ["disabled", "modelValue"])])])]), $options.isHavePushResultCid() ? (_openBlock(), _createElementBlock("div", _hoisted_144, [_createElementVNode("div", _hoisted_145, [_createElementVNode("div", _hoisted_146, [_createElementVNode("div", _hoisted_147, [_createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.$t('Onboarding.Message ID')), 1)])]), _createElementVNode("div", _hoisted_149, [_createElementVNode("div", _hoisted_150, [_createElementVNode("span", {
    class: "link-text-ordinary",
    onClick: _cache[22] || (_cache[22] = $event => $options.gotoHash($data.pushResultCid['/'], _ctx.$i18n.locale))
  }, _toDisplayString($data.pushResultCid['/']), 1), _createElementVNode("span", {
    style: {
      "margin-left": "3px"
    },
    onClick: _cache[23] || (_cache[23] = $event => $options.gotoHash($data.pushResultCid['/'], _ctx.$i18n.locale))
  }, _hoisted_152)])]), _createElementVNode("div", _hoisted_153, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.tryAgainMessage
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.loading ? 'Loading...' : _ctx.$t('Onboarding.Try Again')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])])])) : _createCommentVNode("", true), !$options.isHavePushResultCid() ? (_openBlock(), _createElementBlock("div", _hoisted_154, [_createElementVNode("div", _hoisted_155, [$props.singerMultiple ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_156, [_createElementVNode("div", _hoisted_157, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.confirmSingerReset
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Rest')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])]), _createElementVNode("div", _hoisted_158, [_createElementVNode("div", _hoisted_159, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.pushProposal
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Push')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])])], 64)) : _createCommentVNode("", true), !$props.singerMultiple ? (_openBlock(), _createElementBlock("div", _hoisted_160, [_createElementVNode("div", _hoisted_161, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.pushProposal
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Push')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $data.radio4 === 'Venus Wallet' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_createElementVNode("div", _hoisted_162, [_createElementVNode("div", _hoisted_163, [_createElementVNode("div", _hoisted_164, [_createElementVNode("div", _hoisted_165, [_createElementVNode("span", _hoisted_166, _toDisplayString(_ctx.$t('Onboarding.Sign Message')), 1)]), _createElementVNode("div", _hoisted_167, [_createElementVNode("span", _hoisted_168, _toDisplayString(_ctx.$t('Onboarding.venus Sign message via related offline signature account')), 1)]), _createElementVNode("div", _hoisted_169, [_createElementVNode("div", {
    class: "d-none d-lg-block",
    style: _normalizeStyle([`width: ${$data.signMessageMaxWidth * 1.2}px;`, {
      "word-break": "normal",
      "word-wrap": "break-word"
    }])
  }, " venus-wallet sign " + _toDisplayString($data.singerMsg.From) + " " + _toDisplayString($data.bytesToBeSign), 5), _createElementVNode("div", {
    class: "d-lg-none d-block",
    style: _normalizeStyle([`width: ${$data.signMessageMaxWidth}px;`, {
      "word-break": "normal",
      "word-wrap": "break-word"
    }])
  }, " venus-wallet sign " + _toDisplayString($data.singerMsg.From) + " " + _toDisplayString($data.bytesToBeSign), 5), !$data.isCopy ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "cursor-pointer copy-text fsi-18",
    onClick: _cache[24] || (_cache[24] = (...args) => $options.copy && $options.copy(...args)),
    style: {
      "border": "1px solid #dcdcdc",
      "padding": "6px",
      "display": "inline-flex",
      "border-radius": "5px"
    }
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.isCopy ? (_openBlock(), _createElementBlock("div", _hoisted_170, " copied ")) : _createCommentVNode("", true)])], 512)])]), _createElementVNode("div", _hoisted_171, [_createElementVNode("div", _hoisted_172, [_createElementVNode("div", _hoisted_173, [_createElementVNode("div", _hoisted_174, [_createElementVNode("span", _hoisted_175, _toDisplayString(_ctx.$t('Onboarding.Please enter the result')), 1)])])]), _createElementVNode("div", _hoisted_176, [_createElementVNode("div", _hoisted_177, [_createVNode(_component_el_input, {
    disabled: $data.loading,
    modelValue: $data.inputSingerResult,
    "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.inputSingerResult = $event),
    rows: 3,
    type: "textarea",
    resize: "none"
  }, null, 8, ["disabled", "modelValue"])])])]), $options.isHavePushResultCid() ? (_openBlock(), _createElementBlock("div", _hoisted_178, [_createElementVNode("div", _hoisted_179, [_createElementVNode("div", _hoisted_180, [_createElementVNode("div", _hoisted_181, [_createElementVNode("span", _hoisted_182, _toDisplayString(_ctx.$t('Onboarding.Message ID')), 1)])]), _createElementVNode("div", _hoisted_183, [_createElementVNode("div", _hoisted_184, [_createElementVNode("span", {
    class: "link-text-ordinary",
    onClick: _cache[26] || (_cache[26] = $event => $options.gotoHash($data.pushResultCid['/'], _ctx.$i18n.locale))
  }, _toDisplayString($data.pushResultCid['/']), 1), _createElementVNode("span", {
    style: {
      "margin-left": "3px"
    },
    onClick: _cache[27] || (_cache[27] = $event => $options.gotoHash($data.pushResultCid['/'], _ctx.$i18n.locale))
  }, _hoisted_186)])]), _createElementVNode("div", _hoisted_187, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.tryAgainMessage
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.loading ? 'Loading...' : _ctx.$t('Onboarding.Try Again')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])])])) : _createCommentVNode("", true), !$options.isHavePushResultCid() ? (_openBlock(), _createElementBlock("div", _hoisted_188, [_createElementVNode("div", _hoisted_189, [$props.singerMultiple ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_190, [_createElementVNode("div", _hoisted_191, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.confirmSingerReset
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Rest')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])]), _createElementVNode("div", _hoisted_192, [_createElementVNode("div", _hoisted_193, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.pushProposal
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Push')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])])], 64)) : _createCommentVNode("", true), !$props.singerMultiple ? (_openBlock(), _createElementBlock("div", _hoisted_194, [_createElementVNode("div", _hoisted_195, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    onClick: $options.pushProposal
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Push')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])]);
}